export default "__VITE_ASSET__2Q2b2lkr__"